
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const FilmographyPage = lazy(() => import('../pages/filmography/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/filmography',
    element: <FilmographyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
